import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description BeautyAndHealth icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { BeautyAndHealth } from '@sravni/design-system-icons'
 *
 * <BeautyAndHealth />
 * ```
 */
var BeautyAndHealth = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "BeautyAndHealth", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.5 7.777c0-2.454-2.052-4.444-4.583-4.444-2.532 0-4.584 1.99-4.584 4.444 0 1.018.746 1.842 1.667 1.842.92 0 1.667-.825 1.667-1.842 0-2.454-2.052-4.444-4.584-4.444-2.531 0-4.583 1.99-4.583 4.444 0 5.034 6.018 8.89 7.5 8.89 1.482 0 7.5-3.856 7.5-8.89Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { BeautyAndHealth };
//# sourceMappingURL=BeautyAndHealth.js.map
